import { ChannelIcon, Flex, IconButton, PlusIcon } from '@buffer-mono/popcorn'

import type { Service } from './useChannels'
import { getChannelName } from '~publish/helpers/channels'

import styles from './ChannelSuggestionsIconRow.module.css'

import type { JSX } from 'react'

const MAX_VISIBLE_SUGGESTIONS = 3

type ChannelSuggestionsIconRowProps = {
  services: Service[]
  onChannelClick: (service: Service) => void
  onMoreChannelsClick?: () => void
}

export function ChannelSuggestionsIconRow({
  services,
  onChannelClick,
  onMoreChannelsClick,
}: ChannelSuggestionsIconRowProps): JSX.Element {
  const displayServices = services.slice(0, MAX_VISIBLE_SUGGESTIONS)

  return (
    <Flex gap="xs" align="center" className={styles.iconRow}>
      {displayServices.map((service) => (
        <IconButton
          key={service}
          variant="tertiary"
          size="small"
          label={`Connect ${getChannelName(service)}`}
          tooltip={`Connect ${getChannelName(service)}`}
          onClick={(): void => onChannelClick(service)}
        >
          <ChannelIcon
            className={styles.channelIcon}
            type={service}
            size="small"
          />
        </IconButton>
      ))}
      <IconButton
        variant="tertiary"
        size="small"
        label="More channels"
        tooltip="More channels"
        onClick={onMoreChannelsClick}
      >
        <PlusIcon className={styles.moreIcon} />
      </IconButton>
    </Flex>
  )
}
